<template>
  <section class="cnc-advantage-section">
    <div class="container">
      <div class="text-content">
        <h2 class="section-title">Why XCL for Sheet Metal</h2>
        <p class="section-subtitle">Sourcing simplified for custom sheet metal manufacturing</p>
        
        <h3 class="feature-title">Made As Fast As 1 Day</h3>
        <ul class="feature-list">
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Flexible application options</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Tolerances as low as +/- 0.005”</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Variety of metals (aluminum, steel, brass, copper)</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Cutting, forming, welding</span>
          </li>
          <li class="feature-item">
            <svg class="check-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="white" stroke-width="2"/>
              <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Finishing options (Anodizing, Chem Film, Plating, Media Blasting, Tumbling, Powder Coating with full RAL Color Matching)</span>
          </li>
        </ul>
      </div>

      <div class="visual-content">
        <img src="@/assets/images/2.jpg" alt="Platform Preview" class="platform-img" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Sheet_Why'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.cnc-advantage-section {
  width: 100%;
  background: #fff;
  padding: 42px 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
  background: #16bc9c;
  border-radius: 20px;
  padding: 54px 70px;
}

.text-content {
  color: #fff;
}

.section-title {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 12px;
}

.section-subtitle {
  font-size: 16px;
  opacity: 0.95;
  margin-bottom: 30px;
}

.feature-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f3d36;
  margin-bottom: 20px;
}

.feature-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 🔥 修复图标对齐问题 */
.feature-item {
  display: flex;
  align-items: flex-start; /* 改为 flex-start，让图标和第一行文字顶部对齐 */
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5; /* 增加行高，让多行文字更易读 */
}

.check-icon {
  flex-shrink: 0;
  margin-top: 2px; /* 微调图标位置，使其与文字第一行完全水平居中 */
}

/* 确保图片自适应容器 */
.platform-img {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  background: transparent;
  object-fit: contain; 
}

/* 响应式调整 */
@media (max-width: 1023px) {
  .container {
    grid-template-columns: 1fr;
    gap: 30px; 
    /* 使用 clamp 动态调整 padding，保证在不同尺寸屏幕下都好看 */
    padding: clamp(30px, 6vw, 54px) clamp(20px, 5vw, 70px);
  }
  
  .visual-content {
    width: 100%;
    padding: 0; 
    display: flex;
    justify-content: center;
  }
}
</style>